export const enum Event {
  LoginFormClick = 'login-form_click',
  RegistrationFormClick = 'registration-form_click',
}
